import { render, staticRenderFns } from "./createClinic.vue?vue&type=template&id=52f7e076&"
import script from "./createClinic.vue?vue&type=script&lang=js&"
export * from "./createClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports